import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ExpansionPanelComponent {
  expandedPanel: boolean = false;

  @Input() set expanded(expanded: boolean) {
    this.expandedPanel = expanded;
  }
}
